import { AdStatus, Layout } from "../obituary/types";

export type DaysType = "business_days" | "any_days";

export type PublicationAbbreviation =
  | "LOVA"
  | "BA1"
  | "BA2"
  | "BA3"
  | "BA4"
  | "BA5"
  | "BA6"
  | "BA7"
  | "BA8"
  | "BA9"
  | "BA10"
  | "BA11"
  | "BA12"
  | "BA13"
  | "BA14"
  | "BA15"
  | "BA16"
  | "BA17"
  | "BA18"
  | "BA19"
  | "BA20"
  | "BA21"
  | "BA22"
  | "BA23"
  | "BA24"
  | "BA25"
  | "BA26"
  | "BA27"
  | "BA28"
  | "BA29"
  | "BA30"
  | "BA31"
  | "BA32"
  | "BA33"
  | "BA34"
  | "BA35"
  | "BA36"
  | "BA37"
  | "BA38"
  | "BA39"
  | "BA40"
  | "BA41"
  | "BA42"
  | "BA43"
  | "BA44"
  | "BA45"
  | "BA46"
  | "DN"
  | "BT"
  | "SO"
  | "UT"
  | "BTUT"
  | "TA"
  | "YA"
  | "KBNSKTA"
  | "TAYA"
  | "BLT"
  | "SMP"
  | "BAROT"
  | "BAROTBLT"
  | "BAROTSMP"
  | "OB"
  | "GM11"
  | "GM12"
  | "GM13"
  | "GM21"
  | "GM22"
  | "GM23"
  | "GM24"
  | "GM31"
  | "GM32"
  | "GM33"
  | "GM34"
  | "GM41"
  | "MI1"
  | "AN"
  | "DL"
  | "FT"
  | "FB"
  | "KTK"
  | "MT"
  | "NKP"
  | "NLT"
  | "NWT"
  | "NWT1"
  | "NWT2"
  | "NWT3"
  | "NWT4"
  | "NWT5"
  | "NWT6"
  | "NWT7"
  | "NWT8"
  | "NWT9"
  | "NWT10"
  | "NWT11"
  | "NWT12"
  | "NWT13"
  | "NWT14"
  | "PD"
  | "SLA"
  | "ST"
  | "VF"
  | "NTM11"
  | "NTM12"
  | "NTM13"
  | "NTM14"
  | "NTM15"
  | "NTM16"
  | "NTM17"
  | "NTM18"
  | "NTM19"
  | "NTM110"
  | "NTM111"
  | "NTM112"
  | "NTM113"
  | "NTM21"
  | "NTM22"
  | "NTM31"
  | "NTM32"
  | "NTM33"
  | "NTM41"
  | "GP"
  | "TTELA"
  | "BOH"
  | "HP"
  | "HN"
  | "STNB"
  | "AT"
  | "LT"
  | "KBP"
  | "KP"
  | "MP"
  | "STT"
  | "MKP"
  | "HRP"
  | "PT"
  | "MN"
  | "VK1"
  | "VK2"
  | "VK3"
  | "VK4"
  | "VK5"
  | "VK6";

export interface PublicationSchema {
  abbreviation: PublicationAbbreviation;
  name: string;
}

export interface PublishingRuleCreateSchema {
  from_date: string;
  to_date: string;

  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  days_exceptions: PublishingDaysExceptionSchema[];

  hour: number;
  minute: number;
  publication_lead_time: number;
  days_type: DaysType;
  times_exceptions: StopTimeRuleExceptionSchema[];

  publications: string[];
}

export interface PublishingRuleRetrieveSchema {
  group_id: string;
  from_date: string;
  to_date: string;

  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  days_exceptions: PublishingDaysExceptionSchema[];

  hour: number;
  minute: number;
  publication_lead_time: number;
  days_type: DaysType;
  times_exceptions: StopTimeRuleExceptionSchema[];

  publications: PublicationSchema[];
}

export interface PublishingDaysExceptionSchema {
  day_name: string;
  date: string;
}

export interface StopTimeRuleExceptionSchema {
  for_date: string;
  deadline_date: string;
  hour: number;
  minute: number;
}

export interface MediaUserContextSchema {
  id: number;
  given_name: string;
  family_name: string;
  email: string;
  phone: string;
  publications: PublicationSchema[];
}

export interface ObituaryMediaResponse {
  id: number;
  order_reference?: string;
  order_created_at?: string;
  order_confirmed_at?: string;
  publication_date?: string;
  editing_deadline?: string;
  publication: PublicationSchema;
  layout_variant: Layout;
  approved_at?: string;
  sent_for_review_at?: string;
  story: Story[];
  preview_url: string;
  printing_original_url?: string;
  height: number;
  width: number;
  creator: string;
  creator_email: string;
  marked_for_cancellation_at?: string;
  deceased: DeceasedSchema;
  office: string;
  cost: number;
  discount_pct: number;
  status: AdStatus;
  version: number;
}

export interface DeceasedSchema {
  first_name: string;
  last_name: string;
  birth_date: string;
  deceased_date: string;
  birth_municipality: string;
}

export interface Story {
  gap: boolean;
  flex: string;
  type: string;
  hidden: boolean;
  variant: string;
  children: Child[];
  reference: null;
}

export interface Child {
  src?: string;
  type: string;
  width?: null;
  height?: number;
  hidden: boolean;
  variant: null | string;
  reference: null;
  text?: string;
  date?: Date;
  icon?: string;
  prefix?: null;
  suffix?: null;
  size?: string;
}

export interface DetailedPublicationSchema {
  abbreviation: PublicationAbbreviation;
  name: string;
  nb_orders: number;
  nb_confirmed_orders: number;
  current_rule?: PublishingRuleRetrieveSchema;
}

export interface ObituaryMediaDiff {
  id: number;
  edit_message?: string;
  old_preview_url: string;
  new_preview_url: string;
  changes: ObituaryDiffItems[];
}

export interface ObituaryDiffItems {
  item_name: string;
  old_value: string;
  new_value: string;
}

export interface IndividualRuleSchema {
  exclusions: PublishingDaysExceptionSchema[];
  inclusions: PublishingDaysExceptionSchema[];
  times_exceptions: StopTimeRuleExceptionSchema[];
}

export const days = {
  monday: "Måndag",
  tuesday: "Tisdag",
  wednesday: "Onsdag",
  thursday: "Torsdag",
  friday: "Fredag",
  saturday: "Lördag",
  sunday: "Söndag",
} as const;

export interface WeekdayPrices {
  weekday: string;
  simple_width: number;
  double_width: number;
  memorial: number;
  thanks: number;
  discount_pct: number;
}

export interface PublicationPricesPerDaySchema {
  publication: PublicationAbbreviation;
  days_prices: WeekdayPrices[];
}

export interface PricesGroupSchema {
  from_date: string;
  to_date: string;
  group_id?: string;
  publications_prices: PublicationPricesPerDaySchema[];
}
